// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// versions:
//   protoc-gen-ts_proto  v2.11.5
//   protoc               v7.34.1
// source: functions.proto

/* eslint-disable */
import { BinaryReader, BinaryWriter } from "@bufbuild/protobuf/wire";
import Long from "long";
import { Timestamp } from "./google/protobuf/timestamp";

export const protobufPackage = "functions";

export interface FunctionParameter {
  id: string;
  name: string;
  description: string;
  type: string;
  createdAt: Date | undefined;
  createdBy: string;
  updatedAt: Date | undefined;
  updatedBy: string;
}

export interface FunctionError {
  lineno: number;
  message: string;
  text: string;
}

export interface FunctionDelayResponseReferences {
  variables: { [key: string]: boolean };
}

export interface FunctionDelayResponseReferences_VariablesEntry {
  key: string;
  value: boolean;
}

export interface FunctionDelayResponse {
  id: string;
  message: string;
  duration: number;
  createdAt: Date | undefined;
  createdBy: string;
  updatedAt: Date | undefined;
  updatedBy: string;
  references?: FunctionDelayResponseReferences | undefined;
}

export interface FunctionLatencyControl {
  enabled: boolean;
  delayResponses: FunctionDelayResponse[];
  initialDelay: number;
  interval: number;
  createdAt: Date | undefined;
  createdBy: string;
  updatedAt: Date | undefined;
  updatedBy: string;
}

export interface FunctionReferences {
  flowSteps: { [key: string]: boolean };
  topics: { [key: string]: boolean };
  stopKeywords: { [key: string]: boolean };
  behaviour: { [key: string]: boolean };
  variables: { [key: string]: boolean };
}

export interface FunctionReferences_FlowStepsEntry {
  key: string;
  value: boolean;
}

export interface FunctionReferences_TopicsEntry {
  key: string;
  value: boolean;
}

export interface FunctionReferences_StopKeywordsEntry {
  key: string;
  value: boolean;
}

export interface FunctionReferences_BehaviourEntry {
  key: string;
  value: boolean;
}

export interface FunctionReferences_VariablesEntry {
  key: string;
  value: boolean;
}

export interface FunctionMessage {
  id: string;
  name: string;
  description: string;
  parameters: FunctionParameter[];
  code: string;
  errors: FunctionError[];
  latencyControl: FunctionLatencyControl | undefined;
  createdAt: Date | undefined;
  createdBy: string;
  updatedAt: Date | undefined;
  updatedBy: string;
  archived: boolean;
  references: FunctionReferences | undefined;
}

export interface Functions {
  functions: FunctionMessage[];
}

export interface FunctionParameterUpdate {
  id: string;
  name: string;
  description: string;
  type: string;
}

export interface FunctionCreateLatencyControl {
  enabled: boolean;
  delayResponses: FunctionDelayResponse[];
  initialDelay: number;
  interval: number;
}

export interface FunctionCreateFunction {
  id: string;
  name: string;
  description: string;
  parameters: FunctionParameterUpdate[];
  code: string;
  errors: FunctionError[];
  latencyControl?: FunctionCreateLatencyControl | undefined;
  references?: FunctionReferences | undefined;
  archived?: boolean | undefined;
}

export interface ParametersUpdate {
  parameters: FunctionParameterUpdate[];
}

export interface ErrorsUpdate {
  errors: FunctionError[];
}

export interface FunctionUpdateFunction {
  id: string;
  name?: string | undefined;
  description?: string | undefined;
  parameters?: ParametersUpdate | undefined;
  code?: string | undefined;
  errors?: ErrorsUpdate | undefined;
  references?: FunctionReferences | undefined;
  archived?: boolean | undefined;
}

export interface FunctionDeleteFunction {
  id: string;
}

export interface DelayResponseUpdate {
  id: string;
  message: string;
  duration: number;
  references?: FunctionDelayResponseReferences | undefined;
}

export interface DelayResponsesUpdate {
  delayResponses: DelayResponseUpdate[];
}

export interface FunctionUpdateLatencyControl {
  functionId: string;
  enabled: boolean;
  delayResponses?: DelayResponsesUpdate | undefined;
  initialDelay?: number | undefined;
  interval?: number | undefined;
}

function createBaseFunctionParameter(): FunctionParameter {
  return {
    id: "",
    name: "",
    description: "",
    type: "",
    createdAt: undefined,
    createdBy: "",
    updatedAt: undefined,
    updatedBy: "",
  };
}

export const FunctionParameter: MessageFns<FunctionParameter> = {
  encode(message: FunctionParameter, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.id !== "") {
      writer.uint32(10).string(message.id);
    }
    if (message.name !== "") {
      writer.uint32(18).string(message.name);
    }
    if (message.description !== "") {
      writer.uint32(26).string(message.description);
    }
    if (message.type !== "") {
      writer.uint32(34).string(message.type);
    }
    if (message.createdAt !== undefined) {
      Timestamp.encode(toTimestamp(message.createdAt), writer.uint32(42).fork()).join();
    }
    if (message.createdBy !== "") {
      writer.uint32(50).string(message.createdBy);
    }
    if (message.updatedAt !== undefined) {
      Timestamp.encode(toTimestamp(message.updatedAt), writer.uint32(58).fork()).join();
    }
    if (message.updatedBy !== "") {
      writer.uint32(66).string(message.updatedBy);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): FunctionParameter {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseFunctionParameter();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.id = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.name = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.description = reader.string();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.type = reader.string();
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.createdAt = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
          continue;
        }
        case 6: {
          if (tag !== 50) {
            break;
          }

          message.createdBy = reader.string();
          continue;
        }
        case 7: {
          if (tag !== 58) {
            break;
          }

          message.updatedAt = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
          continue;
        }
        case 8: {
          if (tag !== 66) {
            break;
          }

          message.updatedBy = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): FunctionParameter {
    return {
      id: isSet(object.id) ? globalThis.String(object.id) : "",
      name: isSet(object.name) ? globalThis.String(object.name) : "",
      description: isSet(object.description) ? globalThis.String(object.description) : "",
      type: isSet(object.type) ? globalThis.String(object.type) : "",
      createdAt: isSet(object.createdAt)
        ? fromJsonTimestamp(object.createdAt)
        : isSet(object.created_at)
        ? fromJsonTimestamp(object.created_at)
        : undefined,
      createdBy: isSet(object.createdBy)
        ? globalThis.String(object.createdBy)
        : isSet(object.created_by)
        ? globalThis.String(object.created_by)
        : "",
      updatedAt: isSet(object.updatedAt)
        ? fromJsonTimestamp(object.updatedAt)
        : isSet(object.updated_at)
        ? fromJsonTimestamp(object.updated_at)
        : undefined,
      updatedBy: isSet(object.updatedBy)
        ? globalThis.String(object.updatedBy)
        : isSet(object.updated_by)
        ? globalThis.String(object.updated_by)
        : "",
    };
  },

  toJSON(message: FunctionParameter): unknown {
    const obj: any = {};
    if (message.id !== "") {
      obj.id = message.id;
    }
    if (message.name !== "") {
      obj.name = message.name;
    }
    if (message.description !== "") {
      obj.description = message.description;
    }
    if (message.type !== "") {
      obj.type = message.type;
    }
    if (message.createdAt !== undefined) {
      obj.createdAt = message.createdAt.toISOString();
    }
    if (message.createdBy !== "") {
      obj.createdBy = message.createdBy;
    }
    if (message.updatedAt !== undefined) {
      obj.updatedAt = message.updatedAt.toISOString();
    }
    if (message.updatedBy !== "") {
      obj.updatedBy = message.updatedBy;
    }
    return obj;
  },

  create(base?: DeepPartial<FunctionParameter>): FunctionParameter {
    return FunctionParameter.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<FunctionParameter>): FunctionParameter {
    const message = createBaseFunctionParameter();
    message.id = object.id ?? "";
    message.name = object.name ?? "";
    message.description = object.description ?? "";
    message.type = object.type ?? "";
    message.createdAt = object.createdAt ?? undefined;
    message.createdBy = object.createdBy ?? "";
    message.updatedAt = object.updatedAt ?? undefined;
    message.updatedBy = object.updatedBy ?? "";
    return message;
  },
};

function createBaseFunctionError(): FunctionError {
  return { lineno: 0, message: "", text: "" };
}

export const FunctionError: MessageFns<FunctionError> = {
  encode(message: FunctionError, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.lineno !== 0) {
      writer.uint32(8).int32(message.lineno);
    }
    if (message.message !== "") {
      writer.uint32(18).string(message.message);
    }
    if (message.text !== "") {
      writer.uint32(26).string(message.text);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): FunctionError {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseFunctionError();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.lineno = reader.int32();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.message = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.text = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): FunctionError {
    return {
      lineno: isSet(object.lineno) ? globalThis.Number(object.lineno) : 0,
      message: isSet(object.message) ? globalThis.String(object.message) : "",
      text: isSet(object.text) ? globalThis.String(object.text) : "",
    };
  },

  toJSON(message: FunctionError): unknown {
    const obj: any = {};
    if (message.lineno !== 0) {
      obj.lineno = Math.round(message.lineno);
    }
    if (message.message !== "") {
      obj.message = message.message;
    }
    if (message.text !== "") {
      obj.text = message.text;
    }
    return obj;
  },

  create(base?: DeepPartial<FunctionError>): FunctionError {
    return FunctionError.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<FunctionError>): FunctionError {
    const message = createBaseFunctionError();
    message.lineno = object.lineno ?? 0;
    message.message = object.message ?? "";
    message.text = object.text ?? "";
    return message;
  },
};

function createBaseFunctionDelayResponseReferences(): FunctionDelayResponseReferences {
  return { variables: {} };
}

export const FunctionDelayResponseReferences: MessageFns<FunctionDelayResponseReferences> = {
  encode(message: FunctionDelayResponseReferences, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    globalThis.Object.entries(message.variables).forEach(([key, value]: [string, boolean]) => {
      FunctionDelayResponseReferences_VariablesEntry.encode({ key: key as any, value }, writer.uint32(10).fork())
        .join();
    });
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): FunctionDelayResponseReferences {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseFunctionDelayResponseReferences();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          const entry1 = FunctionDelayResponseReferences_VariablesEntry.decode(reader, reader.uint32());
          if (entry1.value !== undefined) {
            message.variables[entry1.key] = entry1.value;
          }
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): FunctionDelayResponseReferences {
    return {
      variables: isObject(object.variables)
        ? (globalThis.Object.entries(object.variables) as [string, any][]).reduce(
          (acc: { [key: string]: boolean }, [key, value]: [string, any]) => {
            acc[key] = globalThis.Boolean(value);
            return acc;
          },
          {},
        )
        : {},
    };
  },

  toJSON(message: FunctionDelayResponseReferences): unknown {
    const obj: any = {};
    if (message.variables) {
      const entries = globalThis.Object.entries(message.variables) as [string, boolean][];
      if (entries.length > 0) {
        obj.variables = {};
        entries.forEach(([k, v]) => {
          obj.variables[k] = v;
        });
      }
    }
    return obj;
  },

  create(base?: DeepPartial<FunctionDelayResponseReferences>): FunctionDelayResponseReferences {
    return FunctionDelayResponseReferences.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<FunctionDelayResponseReferences>): FunctionDelayResponseReferences {
    const message = createBaseFunctionDelayResponseReferences();
    message.variables = (globalThis.Object.entries(object.variables ?? {}) as [string, boolean][]).reduce(
      (acc: { [key: string]: boolean }, [key, value]: [string, boolean]) => {
        if (value !== undefined) {
          acc[key] = globalThis.Boolean(value);
        }
        return acc;
      },
      {},
    );
    return message;
  },
};

function createBaseFunctionDelayResponseReferences_VariablesEntry(): FunctionDelayResponseReferences_VariablesEntry {
  return { key: "", value: false };
}

export const FunctionDelayResponseReferences_VariablesEntry: MessageFns<
  FunctionDelayResponseReferences_VariablesEntry
> = {
  encode(
    message: FunctionDelayResponseReferences_VariablesEntry,
    writer: BinaryWriter = new BinaryWriter(),
  ): BinaryWriter {
    if (message.key !== "") {
      writer.uint32(10).string(message.key);
    }
    if (message.value !== false) {
      writer.uint32(16).bool(message.value);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): FunctionDelayResponseReferences_VariablesEntry {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseFunctionDelayResponseReferences_VariablesEntry();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.key = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.value = reader.bool();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): FunctionDelayResponseReferences_VariablesEntry {
    return {
      key: isSet(object.key) ? globalThis.String(object.key) : "",
      value: isSet(object.value) ? globalThis.Boolean(object.value) : false,
    };
  },

  toJSON(message: FunctionDelayResponseReferences_VariablesEntry): unknown {
    const obj: any = {};
    if (message.key !== "") {
      obj.key = message.key;
    }
    if (message.value !== false) {
      obj.value = message.value;
    }
    return obj;
  },

  create(
    base?: DeepPartial<FunctionDelayResponseReferences_VariablesEntry>,
  ): FunctionDelayResponseReferences_VariablesEntry {
    return FunctionDelayResponseReferences_VariablesEntry.fromPartial(base ?? {});
  },
  fromPartial(
    object: DeepPartial<FunctionDelayResponseReferences_VariablesEntry>,
  ): FunctionDelayResponseReferences_VariablesEntry {
    const message = createBaseFunctionDelayResponseReferences_VariablesEntry();
    message.key = object.key ?? "";
    message.value = object.value ?? false;
    return message;
  },
};

function createBaseFunctionDelayResponse(): FunctionDelayResponse {
  return {
    id: "",
    message: "",
    duration: 0,
    createdAt: undefined,
    createdBy: "",
    updatedAt: undefined,
    updatedBy: "",
    references: undefined,
  };
}

export const FunctionDelayResponse: MessageFns<FunctionDelayResponse> = {
  encode(message: FunctionDelayResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.id !== "") {
      writer.uint32(10).string(message.id);
    }
    if (message.message !== "") {
      writer.uint32(18).string(message.message);
    }
    if (message.duration !== 0) {
      writer.uint32(24).int32(message.duration);
    }
    if (message.createdAt !== undefined) {
      Timestamp.encode(toTimestamp(message.createdAt), writer.uint32(34).fork()).join();
    }
    if (message.createdBy !== "") {
      writer.uint32(42).string(message.createdBy);
    }
    if (message.updatedAt !== undefined) {
      Timestamp.encode(toTimestamp(message.updatedAt), writer.uint32(50).fork()).join();
    }
    if (message.updatedBy !== "") {
      writer.uint32(58).string(message.updatedBy);
    }
    if (message.references !== undefined) {
      FunctionDelayResponseReferences.encode(message.references, writer.uint32(66).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): FunctionDelayResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseFunctionDelayResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.id = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.message = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 24) {
            break;
          }

          message.duration = reader.int32();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.createdAt = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.createdBy = reader.string();
          continue;
        }
        case 6: {
          if (tag !== 50) {
            break;
          }

          message.updatedAt = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
          continue;
        }
        case 7: {
          if (tag !== 58) {
            break;
          }

          message.updatedBy = reader.string();
          continue;
        }
        case 8: {
          if (tag !== 66) {
            break;
          }

          message.references = FunctionDelayResponseReferences.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): FunctionDelayResponse {
    return {
      id: isSet(object.id) ? globalThis.String(object.id) : "",
      message: isSet(object.message) ? globalThis.String(object.message) : "",
      duration: isSet(object.duration) ? globalThis.Number(object.duration) : 0,
      createdAt: isSet(object.createdAt)
        ? fromJsonTimestamp(object.createdAt)
        : isSet(object.created_at)
        ? fromJsonTimestamp(object.created_at)
        : undefined,
      createdBy: isSet(object.createdBy)
        ? globalThis.String(object.createdBy)
        : isSet(object.created_by)
        ? globalThis.String(object.created_by)
        : "",
      updatedAt: isSet(object.updatedAt)
        ? fromJsonTimestamp(object.updatedAt)
        : isSet(object.updated_at)
        ? fromJsonTimestamp(object.updated_at)
        : undefined,
      updatedBy: isSet(object.updatedBy)
        ? globalThis.String(object.updatedBy)
        : isSet(object.updated_by)
        ? globalThis.String(object.updated_by)
        : "",
      references: isSet(object.references) ? FunctionDelayResponseReferences.fromJSON(object.references) : undefined,
    };
  },

  toJSON(message: FunctionDelayResponse): unknown {
    const obj: any = {};
    if (message.id !== "") {
      obj.id = message.id;
    }
    if (message.message !== "") {
      obj.message = message.message;
    }
    if (message.duration !== 0) {
      obj.duration = Math.round(message.duration);
    }
    if (message.createdAt !== undefined) {
      obj.createdAt = message.createdAt.toISOString();
    }
    if (message.createdBy !== "") {
      obj.createdBy = message.createdBy;
    }
    if (message.updatedAt !== undefined) {
      obj.updatedAt = message.updatedAt.toISOString();
    }
    if (message.updatedBy !== "") {
      obj.updatedBy = message.updatedBy;
    }
    if (message.references !== undefined) {
      obj.references = FunctionDelayResponseReferences.toJSON(message.references);
    }
    return obj;
  },

  create(base?: DeepPartial<FunctionDelayResponse>): FunctionDelayResponse {
    return FunctionDelayResponse.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<FunctionDelayResponse>): FunctionDelayResponse {
    const message = createBaseFunctionDelayResponse();
    message.id = object.id ?? "";
    message.message = object.message ?? "";
    message.duration = object.duration ?? 0;
    message.createdAt = object.createdAt ?? undefined;
    message.createdBy = object.createdBy ?? "";
    message.updatedAt = object.updatedAt ?? undefined;
    message.updatedBy = object.updatedBy ?? "";
    message.references = (object.references !== undefined && object.references !== null)
      ? FunctionDelayResponseReferences.fromPartial(object.references)
      : undefined;
    return message;
  },
};

function createBaseFunctionLatencyControl(): FunctionLatencyControl {
  return {
    enabled: false,
    delayResponses: [],
    initialDelay: 0,
    interval: 0,
    createdAt: undefined,
    createdBy: "",
    updatedAt: undefined,
    updatedBy: "",
  };
}

export const FunctionLatencyControl: MessageFns<FunctionLatencyControl> = {
  encode(message: FunctionLatencyControl, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.enabled !== false) {
      writer.uint32(8).bool(message.enabled);
    }
    for (const v of message.delayResponses) {
      FunctionDelayResponse.encode(v!, writer.uint32(18).fork()).join();
    }
    if (message.initialDelay !== 0) {
      writer.uint32(24).int32(message.initialDelay);
    }
    if (message.interval !== 0) {
      writer.uint32(32).int32(message.interval);
    }
    if (message.createdAt !== undefined) {
      Timestamp.encode(toTimestamp(message.createdAt), writer.uint32(42).fork()).join();
    }
    if (message.createdBy !== "") {
      writer.uint32(50).string(message.createdBy);
    }
    if (message.updatedAt !== undefined) {
      Timestamp.encode(toTimestamp(message.updatedAt), writer.uint32(58).fork()).join();
    }
    if (message.updatedBy !== "") {
      writer.uint32(66).string(message.updatedBy);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): FunctionLatencyControl {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseFunctionLatencyControl();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.enabled = reader.bool();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.delayResponses.push(FunctionDelayResponse.decode(reader, reader.uint32()));
          continue;
        }
        case 3: {
          if (tag !== 24) {
            break;
          }

          message.initialDelay = reader.int32();
          continue;
        }
        case 4: {
          if (tag !== 32) {
            break;
          }

          message.interval = reader.int32();
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.createdAt = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
          continue;
        }
        case 6: {
          if (tag !== 50) {
            break;
          }

          message.createdBy = reader.string();
          continue;
        }
        case 7: {
          if (tag !== 58) {
            break;
          }

          message.updatedAt = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
          continue;
        }
        case 8: {
          if (tag !== 66) {
            break;
          }

          message.updatedBy = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): FunctionLatencyControl {
    return {
      enabled: isSet(object.enabled) ? globalThis.Boolean(object.enabled) : false,
      delayResponses: globalThis.Array.isArray(object?.delayResponses)
        ? object.delayResponses.map((e: any) => FunctionDelayResponse.fromJSON(e))
        : globalThis.Array.isArray(object?.delay_responses)
        ? object.delay_responses.map((e: any) => FunctionDelayResponse.fromJSON(e))
        : [],
      initialDelay: isSet(object.initialDelay)
        ? globalThis.Number(object.initialDelay)
        : isSet(object.initial_delay)
        ? globalThis.Number(object.initial_delay)
        : 0,
      interval: isSet(object.interval) ? globalThis.Number(object.interval) : 0,
      createdAt: isSet(object.createdAt)
        ? fromJsonTimestamp(object.createdAt)
        : isSet(object.created_at)
        ? fromJsonTimestamp(object.created_at)
        : undefined,
      createdBy: isSet(object.createdBy)
        ? globalThis.String(object.createdBy)
        : isSet(object.created_by)
        ? globalThis.String(object.created_by)
        : "",
      updatedAt: isSet(object.updatedAt)
        ? fromJsonTimestamp(object.updatedAt)
        : isSet(object.updated_at)
        ? fromJsonTimestamp(object.updated_at)
        : undefined,
      updatedBy: isSet(object.updatedBy)
        ? globalThis.String(object.updatedBy)
        : isSet(object.updated_by)
        ? globalThis.String(object.updated_by)
        : "",
    };
  },

  toJSON(message: FunctionLatencyControl): unknown {
    const obj: any = {};
    if (message.enabled !== false) {
      obj.enabled = message.enabled;
    }
    if (message.delayResponses?.length) {
      obj.delayResponses = message.delayResponses.map((e) => FunctionDelayResponse.toJSON(e));
    }
    if (message.initialDelay !== 0) {
      obj.initialDelay = Math.round(message.initialDelay);
    }
    if (message.interval !== 0) {
      obj.interval = Math.round(message.interval);
    }
    if (message.createdAt !== undefined) {
      obj.createdAt = message.createdAt.toISOString();
    }
    if (message.createdBy !== "") {
      obj.createdBy = message.createdBy;
    }
    if (message.updatedAt !== undefined) {
      obj.updatedAt = message.updatedAt.toISOString();
    }
    if (message.updatedBy !== "") {
      obj.updatedBy = message.updatedBy;
    }
    return obj;
  },

  create(base?: DeepPartial<FunctionLatencyControl>): FunctionLatencyControl {
    return FunctionLatencyControl.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<FunctionLatencyControl>): FunctionLatencyControl {
    const message = createBaseFunctionLatencyControl();
    message.enabled = object.enabled ?? false;
    message.delayResponses = object.delayResponses?.map((e) => FunctionDelayResponse.fromPartial(e)) || [];
    message.initialDelay = object.initialDelay ?? 0;
    message.interval = object.interval ?? 0;
    message.createdAt = object.createdAt ?? undefined;
    message.createdBy = object.createdBy ?? "";
    message.updatedAt = object.updatedAt ?? undefined;
    message.updatedBy = object.updatedBy ?? "";
    return message;
  },
};

function createBaseFunctionReferences(): FunctionReferences {
  return { flowSteps: {}, topics: {}, stopKeywords: {}, behaviour: {}, variables: {} };
}

export const FunctionReferences: MessageFns<FunctionReferences> = {
  encode(message: FunctionReferences, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    globalThis.Object.entries(message.flowSteps).forEach(([key, value]: [string, boolean]) => {
      FunctionReferences_FlowStepsEntry.encode({ key: key as any, value }, writer.uint32(10).fork()).join();
    });
    globalThis.Object.entries(message.topics).forEach(([key, value]: [string, boolean]) => {
      FunctionReferences_TopicsEntry.encode({ key: key as any, value }, writer.uint32(18).fork()).join();
    });
    globalThis.Object.entries(message.stopKeywords).forEach(([key, value]: [string, boolean]) => {
      FunctionReferences_StopKeywordsEntry.encode({ key: key as any, value }, writer.uint32(26).fork()).join();
    });
    globalThis.Object.entries(message.behaviour).forEach(([key, value]: [string, boolean]) => {
      FunctionReferences_BehaviourEntry.encode({ key: key as any, value }, writer.uint32(34).fork()).join();
    });
    globalThis.Object.entries(message.variables).forEach(([key, value]: [string, boolean]) => {
      FunctionReferences_VariablesEntry.encode({ key: key as any, value }, writer.uint32(42).fork()).join();
    });
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): FunctionReferences {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseFunctionReferences();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          const entry1 = FunctionReferences_FlowStepsEntry.decode(reader, reader.uint32());
          if (entry1.value !== undefined) {
            message.flowSteps[entry1.key] = entry1.value;
          }
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          const entry2 = FunctionReferences_TopicsEntry.decode(reader, reader.uint32());
          if (entry2.value !== undefined) {
            message.topics[entry2.key] = entry2.value;
          }
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          const entry3 = FunctionReferences_StopKeywordsEntry.decode(reader, reader.uint32());
          if (entry3.value !== undefined) {
            message.stopKeywords[entry3.key] = entry3.value;
          }
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          const entry4 = FunctionReferences_BehaviourEntry.decode(reader, reader.uint32());
          if (entry4.value !== undefined) {
            message.behaviour[entry4.key] = entry4.value;
          }
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          const entry5 = FunctionReferences_VariablesEntry.decode(reader, reader.uint32());
          if (entry5.value !== undefined) {
            message.variables[entry5.key] = entry5.value;
          }
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): FunctionReferences {
    return {
      flowSteps: isObject(object.flowSteps)
        ? (globalThis.Object.entries(object.flowSteps) as [string, any][]).reduce(
          (acc: { [key: string]: boolean }, [key, value]: [string, any]) => {
            acc[key] = globalThis.Boolean(value);
            return acc;
          },
          {},
        )
        : isObject(object.flow_steps)
        ? (globalThis.Object.entries(object.flow_steps) as [string, any][]).reduce(
          (acc: { [key: string]: boolean }, [key, value]: [string, any]) => {
            acc[key] = globalThis.Boolean(value);
            return acc;
          },
          {},
        )
        : {},
      topics: isObject(object.topics)
        ? (globalThis.Object.entries(object.topics) as [string, any][]).reduce(
          (acc: { [key: string]: boolean }, [key, value]: [string, any]) => {
            acc[key] = globalThis.Boolean(value);
            return acc;
          },
          {},
        )
        : {},
      stopKeywords: isObject(object.stopKeywords)
        ? (globalThis.Object.entries(object.stopKeywords) as [string, any][]).reduce(
          (acc: { [key: string]: boolean }, [key, value]: [string, any]) => {
            acc[key] = globalThis.Boolean(value);
            return acc;
          },
          {},
        )
        : isObject(object.stop_keywords)
        ? (globalThis.Object.entries(object.stop_keywords) as [string, any][]).reduce(
          (acc: { [key: string]: boolean }, [key, value]: [string, any]) => {
            acc[key] = globalThis.Boolean(value);
            return acc;
          },
          {},
        )
        : {},
      behaviour: isObject(object.behaviour)
        ? (globalThis.Object.entries(object.behaviour) as [string, any][]).reduce(
          (acc: { [key: string]: boolean }, [key, value]: [string, any]) => {
            acc[key] = globalThis.Boolean(value);
            return acc;
          },
          {},
        )
        : {},
      variables: isObject(object.variables)
        ? (globalThis.Object.entries(object.variables) as [string, any][]).reduce(
          (acc: { [key: string]: boolean }, [key, value]: [string, any]) => {
            acc[key] = globalThis.Boolean(value);
            return acc;
          },
          {},
        )
        : {},
    };
  },

  toJSON(message: FunctionReferences): unknown {
    const obj: any = {};
    if (message.flowSteps) {
      const entries = globalThis.Object.entries(message.flowSteps) as [string, boolean][];
      if (entries.length > 0) {
        obj.flowSteps = {};
        entries.forEach(([k, v]) => {
          obj.flowSteps[k] = v;
        });
      }
    }
    if (message.topics) {
      const entries = globalThis.Object.entries(message.topics) as [string, boolean][];
      if (entries.length > 0) {
        obj.topics = {};
        entries.forEach(([k, v]) => {
          obj.topics[k] = v;
        });
      }
    }
    if (message.stopKeywords) {
      const entries = globalThis.Object.entries(message.stopKeywords) as [string, boolean][];
      if (entries.length > 0) {
        obj.stopKeywords = {};
        entries.forEach(([k, v]) => {
          obj.stopKeywords[k] = v;
        });
      }
    }
    if (message.behaviour) {
      const entries = globalThis.Object.entries(message.behaviour) as [string, boolean][];
      if (entries.length > 0) {
        obj.behaviour = {};
        entries.forEach(([k, v]) => {
          obj.behaviour[k] = v;
        });
      }
    }
    if (message.variables) {
      const entries = globalThis.Object.entries(message.variables) as [string, boolean][];
      if (entries.length > 0) {
        obj.variables = {};
        entries.forEach(([k, v]) => {
          obj.variables[k] = v;
        });
      }
    }
    return obj;
  },

  create(base?: DeepPartial<FunctionReferences>): FunctionReferences {
    return FunctionReferences.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<FunctionReferences>): FunctionReferences {
    const message = createBaseFunctionReferences();
    message.flowSteps = (globalThis.Object.entries(object.flowSteps ?? {}) as [string, boolean][]).reduce(
      (acc: { [key: string]: boolean }, [key, value]: [string, boolean]) => {
        if (value !== undefined) {
          acc[key] = globalThis.Boolean(value);
        }
        return acc;
      },
      {},
    );
    message.topics = (globalThis.Object.entries(object.topics ?? {}) as [string, boolean][]).reduce(
      (acc: { [key: string]: boolean }, [key, value]: [string, boolean]) => {
        if (value !== undefined) {
          acc[key] = globalThis.Boolean(value);
        }
        return acc;
      },
      {},
    );
    message.stopKeywords = (globalThis.Object.entries(object.stopKeywords ?? {}) as [string, boolean][]).reduce(
      (acc: { [key: string]: boolean }, [key, value]: [string, boolean]) => {
        if (value !== undefined) {
          acc[key] = globalThis.Boolean(value);
        }
        return acc;
      },
      {},
    );
    message.behaviour = (globalThis.Object.entries(object.behaviour ?? {}) as [string, boolean][]).reduce(
      (acc: { [key: string]: boolean }, [key, value]: [string, boolean]) => {
        if (value !== undefined) {
          acc[key] = globalThis.Boolean(value);
        }
        return acc;
      },
      {},
    );
    message.variables = (globalThis.Object.entries(object.variables ?? {}) as [string, boolean][]).reduce(
      (acc: { [key: string]: boolean }, [key, value]: [string, boolean]) => {
        if (value !== undefined) {
          acc[key] = globalThis.Boolean(value);
        }
        return acc;
      },
      {},
    );
    return message;
  },
};

function createBaseFunctionReferences_FlowStepsEntry(): FunctionReferences_FlowStepsEntry {
  return { key: "", value: false };
}

export const FunctionReferences_FlowStepsEntry: MessageFns<FunctionReferences_FlowStepsEntry> = {
  encode(message: FunctionReferences_FlowStepsEntry, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.key !== "") {
      writer.uint32(10).string(message.key);
    }
    if (message.value !== false) {
      writer.uint32(16).bool(message.value);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): FunctionReferences_FlowStepsEntry {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseFunctionReferences_FlowStepsEntry();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.key = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.value = reader.bool();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): FunctionReferences_FlowStepsEntry {
    return {
      key: isSet(object.key) ? globalThis.String(object.key) : "",
      value: isSet(object.value) ? globalThis.Boolean(object.value) : false,
    };
  },

  toJSON(message: FunctionReferences_FlowStepsEntry): unknown {
    const obj: any = {};
    if (message.key !== "") {
      obj.key = message.key;
    }
    if (message.value !== false) {
      obj.value = message.value;
    }
    return obj;
  },

  create(base?: DeepPartial<FunctionReferences_FlowStepsEntry>): FunctionReferences_FlowStepsEntry {
    return FunctionReferences_FlowStepsEntry.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<FunctionReferences_FlowStepsEntry>): FunctionReferences_FlowStepsEntry {
    const message = createBaseFunctionReferences_FlowStepsEntry();
    message.key = object.key ?? "";
    message.value = object.value ?? false;
    return message;
  },
};

function createBaseFunctionReferences_TopicsEntry(): FunctionReferences_TopicsEntry {
  return { key: "", value: false };
}

export const FunctionReferences_TopicsEntry: MessageFns<FunctionReferences_TopicsEntry> = {
  encode(message: FunctionReferences_TopicsEntry, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.key !== "") {
      writer.uint32(10).string(message.key);
    }
    if (message.value !== false) {
      writer.uint32(16).bool(message.value);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): FunctionReferences_TopicsEntry {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseFunctionReferences_TopicsEntry();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.key = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.value = reader.bool();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): FunctionReferences_TopicsEntry {
    return {
      key: isSet(object.key) ? globalThis.String(object.key) : "",
      value: isSet(object.value) ? globalThis.Boolean(object.value) : false,
    };
  },

  toJSON(message: FunctionReferences_TopicsEntry): unknown {
    const obj: any = {};
    if (message.key !== "") {
      obj.key = message.key;
    }
    if (message.value !== false) {
      obj.value = message.value;
    }
    return obj;
  },

  create(base?: DeepPartial<FunctionReferences_TopicsEntry>): FunctionReferences_TopicsEntry {
    return FunctionReferences_TopicsEntry.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<FunctionReferences_TopicsEntry>): FunctionReferences_TopicsEntry {
    const message = createBaseFunctionReferences_TopicsEntry();
    message.key = object.key ?? "";
    message.value = object.value ?? false;
    return message;
  },
};

function createBaseFunctionReferences_StopKeywordsEntry(): FunctionReferences_StopKeywordsEntry {
  return { key: "", value: false };
}

export const FunctionReferences_StopKeywordsEntry: MessageFns<FunctionReferences_StopKeywordsEntry> = {
  encode(message: FunctionReferences_StopKeywordsEntry, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.key !== "") {
      writer.uint32(10).string(message.key);
    }
    if (message.value !== false) {
      writer.uint32(16).bool(message.value);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): FunctionReferences_StopKeywordsEntry {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseFunctionReferences_StopKeywordsEntry();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.key = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.value = reader.bool();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): FunctionReferences_StopKeywordsEntry {
    return {
      key: isSet(object.key) ? globalThis.String(object.key) : "",
      value: isSet(object.value) ? globalThis.Boolean(object.value) : false,
    };
  },

  toJSON(message: FunctionReferences_StopKeywordsEntry): unknown {
    const obj: any = {};
    if (message.key !== "") {
      obj.key = message.key;
    }
    if (message.value !== false) {
      obj.value = message.value;
    }
    return obj;
  },

  create(base?: DeepPartial<FunctionReferences_StopKeywordsEntry>): FunctionReferences_StopKeywordsEntry {
    return FunctionReferences_StopKeywordsEntry.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<FunctionReferences_StopKeywordsEntry>): FunctionReferences_StopKeywordsEntry {
    const message = createBaseFunctionReferences_StopKeywordsEntry();
    message.key = object.key ?? "";
    message.value = object.value ?? false;
    return message;
  },
};

function createBaseFunctionReferences_BehaviourEntry(): FunctionReferences_BehaviourEntry {
  return { key: "", value: false };
}

export const FunctionReferences_BehaviourEntry: MessageFns<FunctionReferences_BehaviourEntry> = {
  encode(message: FunctionReferences_BehaviourEntry, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.key !== "") {
      writer.uint32(10).string(message.key);
    }
    if (message.value !== false) {
      writer.uint32(16).bool(message.value);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): FunctionReferences_BehaviourEntry {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseFunctionReferences_BehaviourEntry();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.key = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.value = reader.bool();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): FunctionReferences_BehaviourEntry {
    return {
      key: isSet(object.key) ? globalThis.String(object.key) : "",
      value: isSet(object.value) ? globalThis.Boolean(object.value) : false,
    };
  },

  toJSON(message: FunctionReferences_BehaviourEntry): unknown {
    const obj: any = {};
    if (message.key !== "") {
      obj.key = message.key;
    }
    if (message.value !== false) {
      obj.value = message.value;
    }
    return obj;
  },

  create(base?: DeepPartial<FunctionReferences_BehaviourEntry>): FunctionReferences_BehaviourEntry {
    return FunctionReferences_BehaviourEntry.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<FunctionReferences_BehaviourEntry>): FunctionReferences_BehaviourEntry {
    const message = createBaseFunctionReferences_BehaviourEntry();
    message.key = object.key ?? "";
    message.value = object.value ?? false;
    return message;
  },
};

function createBaseFunctionReferences_VariablesEntry(): FunctionReferences_VariablesEntry {
  return { key: "", value: false };
}

export const FunctionReferences_VariablesEntry: MessageFns<FunctionReferences_VariablesEntry> = {
  encode(message: FunctionReferences_VariablesEntry, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.key !== "") {
      writer.uint32(10).string(message.key);
    }
    if (message.value !== false) {
      writer.uint32(16).bool(message.value);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): FunctionReferences_VariablesEntry {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseFunctionReferences_VariablesEntry();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.key = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.value = reader.bool();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): FunctionReferences_VariablesEntry {
    return {
      key: isSet(object.key) ? globalThis.String(object.key) : "",
      value: isSet(object.value) ? globalThis.Boolean(object.value) : false,
    };
  },

  toJSON(message: FunctionReferences_VariablesEntry): unknown {
    const obj: any = {};
    if (message.key !== "") {
      obj.key = message.key;
    }
    if (message.value !== false) {
      obj.value = message.value;
    }
    return obj;
  },

  create(base?: DeepPartial<FunctionReferences_VariablesEntry>): FunctionReferences_VariablesEntry {
    return FunctionReferences_VariablesEntry.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<FunctionReferences_VariablesEntry>): FunctionReferences_VariablesEntry {
    const message = createBaseFunctionReferences_VariablesEntry();
    message.key = object.key ?? "";
    message.value = object.value ?? false;
    return message;
  },
};

function createBaseFunctionMessage(): FunctionMessage {
  return {
    id: "",
    name: "",
    description: "",
    parameters: [],
    code: "",
    errors: [],
    latencyControl: undefined,
    createdAt: undefined,
    createdBy: "",
    updatedAt: undefined,
    updatedBy: "",
    archived: false,
    references: undefined,
  };
}

export const FunctionMessage: MessageFns<FunctionMessage> = {
  encode(message: FunctionMessage, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.id !== "") {
      writer.uint32(10).string(message.id);
    }
    if (message.name !== "") {
      writer.uint32(18).string(message.name);
    }
    if (message.description !== "") {
      writer.uint32(26).string(message.description);
    }
    for (const v of message.parameters) {
      FunctionParameter.encode(v!, writer.uint32(34).fork()).join();
    }
    if (message.code !== "") {
      writer.uint32(42).string(message.code);
    }
    for (const v of message.errors) {
      FunctionError.encode(v!, writer.uint32(50).fork()).join();
    }
    if (message.latencyControl !== undefined) {
      FunctionLatencyControl.encode(message.latencyControl, writer.uint32(58).fork()).join();
    }
    if (message.createdAt !== undefined) {
      Timestamp.encode(toTimestamp(message.createdAt), writer.uint32(66).fork()).join();
    }
    if (message.createdBy !== "") {
      writer.uint32(74).string(message.createdBy);
    }
    if (message.updatedAt !== undefined) {
      Timestamp.encode(toTimestamp(message.updatedAt), writer.uint32(82).fork()).join();
    }
    if (message.updatedBy !== "") {
      writer.uint32(90).string(message.updatedBy);
    }
    if (message.archived !== false) {
      writer.uint32(96).bool(message.archived);
    }
    if (message.references !== undefined) {
      FunctionReferences.encode(message.references, writer.uint32(106).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): FunctionMessage {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseFunctionMessage();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.id = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.name = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.description = reader.string();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.parameters.push(FunctionParameter.decode(reader, reader.uint32()));
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.code = reader.string();
          continue;
        }
        case 6: {
          if (tag !== 50) {
            break;
          }

          message.errors.push(FunctionError.decode(reader, reader.uint32()));
          continue;
        }
        case 7: {
          if (tag !== 58) {
            break;
          }

          message.latencyControl = FunctionLatencyControl.decode(reader, reader.uint32());
          continue;
        }
        case 8: {
          if (tag !== 66) {
            break;
          }

          message.createdAt = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
          continue;
        }
        case 9: {
          if (tag !== 74) {
            break;
          }

          message.createdBy = reader.string();
          continue;
        }
        case 10: {
          if (tag !== 82) {
            break;
          }

          message.updatedAt = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
          continue;
        }
        case 11: {
          if (tag !== 90) {
            break;
          }

          message.updatedBy = reader.string();
          continue;
        }
        case 12: {
          if (tag !== 96) {
            break;
          }

          message.archived = reader.bool();
          continue;
        }
        case 13: {
          if (tag !== 106) {
            break;
          }

          message.references = FunctionReferences.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): FunctionMessage {
    return {
      id: isSet(object.id) ? globalThis.String(object.id) : "",
      name: isSet(object.name) ? globalThis.String(object.name) : "",
      description: isSet(object.description) ? globalThis.String(object.description) : "",
      parameters: globalThis.Array.isArray(object?.parameters)
        ? object.parameters.map((e: any) => FunctionParameter.fromJSON(e))
        : [],
      code: isSet(object.code) ? globalThis.String(object.code) : "",
      errors: globalThis.Array.isArray(object?.errors) ? object.errors.map((e: any) => FunctionError.fromJSON(e)) : [],
      latencyControl: isSet(object.latencyControl)
        ? FunctionLatencyControl.fromJSON(object.latencyControl)
        : isSet(object.latency_control)
        ? FunctionLatencyControl.fromJSON(object.latency_control)
        : undefined,
      createdAt: isSet(object.createdAt)
        ? fromJsonTimestamp(object.createdAt)
        : isSet(object.created_at)
        ? fromJsonTimestamp(object.created_at)
        : undefined,
      createdBy: isSet(object.createdBy)
        ? globalThis.String(object.createdBy)
        : isSet(object.created_by)
        ? globalThis.String(object.created_by)
        : "",
      updatedAt: isSet(object.updatedAt)
        ? fromJsonTimestamp(object.updatedAt)
        : isSet(object.updated_at)
        ? fromJsonTimestamp(object.updated_at)
        : undefined,
      updatedBy: isSet(object.updatedBy)
        ? globalThis.String(object.updatedBy)
        : isSet(object.updated_by)
        ? globalThis.String(object.updated_by)
        : "",
      archived: isSet(object.archived) ? globalThis.Boolean(object.archived) : false,
      references: isSet(object.references) ? FunctionReferences.fromJSON(object.references) : undefined,
    };
  },

  toJSON(message: FunctionMessage): unknown {
    const obj: any = {};
    if (message.id !== "") {
      obj.id = message.id;
    }
    if (message.name !== "") {
      obj.name = message.name;
    }
    if (message.description !== "") {
      obj.description = message.description;
    }
    if (message.parameters?.length) {
      obj.parameters = message.parameters.map((e) => FunctionParameter.toJSON(e));
    }
    if (message.code !== "") {
      obj.code = message.code;
    }
    if (message.errors?.length) {
      obj.errors = message.errors.map((e) => FunctionError.toJSON(e));
    }
    if (message.latencyControl !== undefined) {
      obj.latencyControl = FunctionLatencyControl.toJSON(message.latencyControl);
    }
    if (message.createdAt !== undefined) {
      obj.createdAt = message.createdAt.toISOString();
    }
    if (message.createdBy !== "") {
      obj.createdBy = message.createdBy;
    }
    if (message.updatedAt !== undefined) {
      obj.updatedAt = message.updatedAt.toISOString();
    }
    if (message.updatedBy !== "") {
      obj.updatedBy = message.updatedBy;
    }
    if (message.archived !== false) {
      obj.archived = message.archived;
    }
    if (message.references !== undefined) {
      obj.references = FunctionReferences.toJSON(message.references);
    }
    return obj;
  },

  create(base?: DeepPartial<FunctionMessage>): FunctionMessage {
    return FunctionMessage.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<FunctionMessage>): FunctionMessage {
    const message = createBaseFunctionMessage();
    message.id = object.id ?? "";
    message.name = object.name ?? "";
    message.description = object.description ?? "";
    message.parameters = object.parameters?.map((e) => FunctionParameter.fromPartial(e)) || [];
    message.code = object.code ?? "";
    message.errors = object.errors?.map((e) => FunctionError.fromPartial(e)) || [];
    message.latencyControl = (object.latencyControl !== undefined && object.latencyControl !== null)
      ? FunctionLatencyControl.fromPartial(object.latencyControl)
      : undefined;
    message.createdAt = object.createdAt ?? undefined;
    message.createdBy = object.createdBy ?? "";
    message.updatedAt = object.updatedAt ?? undefined;
    message.updatedBy = object.updatedBy ?? "";
    message.archived = object.archived ?? false;
    message.references = (object.references !== undefined && object.references !== null)
      ? FunctionReferences.fromPartial(object.references)
      : undefined;
    return message;
  },
};

function createBaseFunctions(): Functions {
  return { functions: [] };
}

export const Functions: MessageFns<Functions> = {
  encode(message: Functions, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    for (const v of message.functions) {
      FunctionMessage.encode(v!, writer.uint32(10).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): Functions {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseFunctions();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.functions.push(FunctionMessage.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): Functions {
    return {
      functions: globalThis.Array.isArray(object?.functions)
        ? object.functions.map((e: any) => FunctionMessage.fromJSON(e))
        : [],
    };
  },

  toJSON(message: Functions): unknown {
    const obj: any = {};
    if (message.functions?.length) {
      obj.functions = message.functions.map((e) => FunctionMessage.toJSON(e));
    }
    return obj;
  },

  create(base?: DeepPartial<Functions>): Functions {
    return Functions.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<Functions>): Functions {
    const message = createBaseFunctions();
    message.functions = object.functions?.map((e) => FunctionMessage.fromPartial(e)) || [];
    return message;
  },
};

function createBaseFunctionParameterUpdate(): FunctionParameterUpdate {
  return { id: "", name: "", description: "", type: "" };
}

export const FunctionParameterUpdate: MessageFns<FunctionParameterUpdate> = {
  encode(message: FunctionParameterUpdate, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.id !== "") {
      writer.uint32(10).string(message.id);
    }
    if (message.name !== "") {
      writer.uint32(18).string(message.name);
    }
    if (message.description !== "") {
      writer.uint32(26).string(message.description);
    }
    if (message.type !== "") {
      writer.uint32(34).string(message.type);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): FunctionParameterUpdate {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseFunctionParameterUpdate();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.id = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.name = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.description = reader.string();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.type = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): FunctionParameterUpdate {
    return {
      id: isSet(object.id) ? globalThis.String(object.id) : "",
      name: isSet(object.name) ? globalThis.String(object.name) : "",
      description: isSet(object.description) ? globalThis.String(object.description) : "",
      type: isSet(object.type) ? globalThis.String(object.type) : "",
    };
  },

  toJSON(message: FunctionParameterUpdate): unknown {
    const obj: any = {};
    if (message.id !== "") {
      obj.id = message.id;
    }
    if (message.name !== "") {
      obj.name = message.name;
    }
    if (message.description !== "") {
      obj.description = message.description;
    }
    if (message.type !== "") {
      obj.type = message.type;
    }
    return obj;
  },

  create(base?: DeepPartial<FunctionParameterUpdate>): FunctionParameterUpdate {
    return FunctionParameterUpdate.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<FunctionParameterUpdate>): FunctionParameterUpdate {
    const message = createBaseFunctionParameterUpdate();
    message.id = object.id ?? "";
    message.name = object.name ?? "";
    message.description = object.description ?? "";
    message.type = object.type ?? "";
    return message;
  },
};

function createBaseFunctionCreateLatencyControl(): FunctionCreateLatencyControl {
  return { enabled: false, delayResponses: [], initialDelay: 0, interval: 0 };
}

export const FunctionCreateLatencyControl: MessageFns<FunctionCreateLatencyControl> = {
  encode(message: FunctionCreateLatencyControl, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.enabled !== false) {
      writer.uint32(8).bool(message.enabled);
    }
    for (const v of message.delayResponses) {
      FunctionDelayResponse.encode(v!, writer.uint32(18).fork()).join();
    }
    if (message.initialDelay !== 0) {
      writer.uint32(24).int32(message.initialDelay);
    }
    if (message.interval !== 0) {
      writer.uint32(32).int32(message.interval);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): FunctionCreateLatencyControl {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseFunctionCreateLatencyControl();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.enabled = reader.bool();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.delayResponses.push(FunctionDelayResponse.decode(reader, reader.uint32()));
          continue;
        }
        case 3: {
          if (tag !== 24) {
            break;
          }

          message.initialDelay = reader.int32();
          continue;
        }
        case 4: {
          if (tag !== 32) {
            break;
          }

          message.interval = reader.int32();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): FunctionCreateLatencyControl {
    return {
      enabled: isSet(object.enabled) ? globalThis.Boolean(object.enabled) : false,
      delayResponses: globalThis.Array.isArray(object?.delayResponses)
        ? object.delayResponses.map((e: any) => FunctionDelayResponse.fromJSON(e))
        : globalThis.Array.isArray(object?.delay_responses)
        ? object.delay_responses.map((e: any) => FunctionDelayResponse.fromJSON(e))
        : [],
      initialDelay: isSet(object.initialDelay)
        ? globalThis.Number(object.initialDelay)
        : isSet(object.initial_delay)
        ? globalThis.Number(object.initial_delay)
        : 0,
      interval: isSet(object.interval) ? globalThis.Number(object.interval) : 0,
    };
  },

  toJSON(message: FunctionCreateLatencyControl): unknown {
    const obj: any = {};
    if (message.enabled !== false) {
      obj.enabled = message.enabled;
    }
    if (message.delayResponses?.length) {
      obj.delayResponses = message.delayResponses.map((e) => FunctionDelayResponse.toJSON(e));
    }
    if (message.initialDelay !== 0) {
      obj.initialDelay = Math.round(message.initialDelay);
    }
    if (message.interval !== 0) {
      obj.interval = Math.round(message.interval);
    }
    return obj;
  },

  create(base?: DeepPartial<FunctionCreateLatencyControl>): FunctionCreateLatencyControl {
    return FunctionCreateLatencyControl.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<FunctionCreateLatencyControl>): FunctionCreateLatencyControl {
    const message = createBaseFunctionCreateLatencyControl();
    message.enabled = object.enabled ?? false;
    message.delayResponses = object.delayResponses?.map((e) => FunctionDelayResponse.fromPartial(e)) || [];
    message.initialDelay = object.initialDelay ?? 0;
    message.interval = object.interval ?? 0;
    return message;
  },
};

function createBaseFunctionCreateFunction(): FunctionCreateFunction {
  return {
    id: "",
    name: "",
    description: "",
    parameters: [],
    code: "",
    errors: [],
    latencyControl: undefined,
    references: undefined,
    archived: undefined,
  };
}

export const FunctionCreateFunction: MessageFns<FunctionCreateFunction> = {
  encode(message: FunctionCreateFunction, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.id !== "") {
      writer.uint32(10).string(message.id);
    }
    if (message.name !== "") {
      writer.uint32(18).string(message.name);
    }
    if (message.description !== "") {
      writer.uint32(26).string(message.description);
    }
    for (const v of message.parameters) {
      FunctionParameterUpdate.encode(v!, writer.uint32(34).fork()).join();
    }
    if (message.code !== "") {
      writer.uint32(42).string(message.code);
    }
    for (const v of message.errors) {
      FunctionError.encode(v!, writer.uint32(50).fork()).join();
    }
    if (message.latencyControl !== undefined) {
      FunctionCreateLatencyControl.encode(message.latencyControl, writer.uint32(58).fork()).join();
    }
    if (message.references !== undefined) {
      FunctionReferences.encode(message.references, writer.uint32(66).fork()).join();
    }
    if (message.archived !== undefined) {
      writer.uint32(72).bool(message.archived);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): FunctionCreateFunction {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseFunctionCreateFunction();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.id = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.name = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.description = reader.string();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.parameters.push(FunctionParameterUpdate.decode(reader, reader.uint32()));
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.code = reader.string();
          continue;
        }
        case 6: {
          if (tag !== 50) {
            break;
          }

          message.errors.push(FunctionError.decode(reader, reader.uint32()));
          continue;
        }
        case 7: {
          if (tag !== 58) {
            break;
          }

          message.latencyControl = FunctionCreateLatencyControl.decode(reader, reader.uint32());
          continue;
        }
        case 8: {
          if (tag !== 66) {
            break;
          }

          message.references = FunctionReferences.decode(reader, reader.uint32());
          continue;
        }
        case 9: {
          if (tag !== 72) {
            break;
          }

          message.archived = reader.bool();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): FunctionCreateFunction {
    return {
      id: isSet(object.id) ? globalThis.String(object.id) : "",
      name: isSet(object.name) ? globalThis.String(object.name) : "",
      description: isSet(object.description) ? globalThis.String(object.description) : "",
      parameters: globalThis.Array.isArray(object?.parameters)
        ? object.parameters.map((e: any) => FunctionParameterUpdate.fromJSON(e))
        : [],
      code: isSet(object.code) ? globalThis.String(object.code) : "",
      errors: globalThis.Array.isArray(object?.errors) ? object.errors.map((e: any) => FunctionError.fromJSON(e)) : [],
      latencyControl: isSet(object.latencyControl)
        ? FunctionCreateLatencyControl.fromJSON(object.latencyControl)
        : isSet(object.latency_control)
        ? FunctionCreateLatencyControl.fromJSON(object.latency_control)
        : undefined,
      references: isSet(object.references) ? FunctionReferences.fromJSON(object.references) : undefined,
      archived: isSet(object.archived) ? globalThis.Boolean(object.archived) : undefined,
    };
  },

  toJSON(message: FunctionCreateFunction): unknown {
    const obj: any = {};
    if (message.id !== "") {
      obj.id = message.id;
    }
    if (message.name !== "") {
      obj.name = message.name;
    }
    if (message.description !== "") {
      obj.description = message.description;
    }
    if (message.parameters?.length) {
      obj.parameters = message.parameters.map((e) => FunctionParameterUpdate.toJSON(e));
    }
    if (message.code !== "") {
      obj.code = message.code;
    }
    if (message.errors?.length) {
      obj.errors = message.errors.map((e) => FunctionError.toJSON(e));
    }
    if (message.latencyControl !== undefined) {
      obj.latencyControl = FunctionCreateLatencyControl.toJSON(message.latencyControl);
    }
    if (message.references !== undefined) {
      obj.references = FunctionReferences.toJSON(message.references);
    }
    if (message.archived !== undefined) {
      obj.archived = message.archived;
    }
    return obj;
  },

  create(base?: DeepPartial<FunctionCreateFunction>): FunctionCreateFunction {
    return FunctionCreateFunction.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<FunctionCreateFunction>): FunctionCreateFunction {
    const message = createBaseFunctionCreateFunction();
    message.id = object.id ?? "";
    message.name = object.name ?? "";
    message.description = object.description ?? "";
    message.parameters = object.parameters?.map((e) => FunctionParameterUpdate.fromPartial(e)) || [];
    message.code = object.code ?? "";
    message.errors = object.errors?.map((e) => FunctionError.fromPartial(e)) || [];
    message.latencyControl = (object.latencyControl !== undefined && object.latencyControl !== null)
      ? FunctionCreateLatencyControl.fromPartial(object.latencyControl)
      : undefined;
    message.references = (object.references !== undefined && object.references !== null)
      ? FunctionReferences.fromPartial(object.references)
      : undefined;
    message.archived = object.archived ?? undefined;
    return message;
  },
};

function createBaseParametersUpdate(): ParametersUpdate {
  return { parameters: [] };
}

export const ParametersUpdate: MessageFns<ParametersUpdate> = {
  encode(message: ParametersUpdate, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    for (const v of message.parameters) {
      FunctionParameterUpdate.encode(v!, writer.uint32(10).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ParametersUpdate {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseParametersUpdate();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.parameters.push(FunctionParameterUpdate.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): ParametersUpdate {
    return {
      parameters: globalThis.Array.isArray(object?.parameters)
        ? object.parameters.map((e: any) => FunctionParameterUpdate.fromJSON(e))
        : [],
    };
  },

  toJSON(message: ParametersUpdate): unknown {
    const obj: any = {};
    if (message.parameters?.length) {
      obj.parameters = message.parameters.map((e) => FunctionParameterUpdate.toJSON(e));
    }
    return obj;
  },

  create(base?: DeepPartial<ParametersUpdate>): ParametersUpdate {
    return ParametersUpdate.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<ParametersUpdate>): ParametersUpdate {
    const message = createBaseParametersUpdate();
    message.parameters = object.parameters?.map((e) => FunctionParameterUpdate.fromPartial(e)) || [];
    return message;
  },
};

function createBaseErrorsUpdate(): ErrorsUpdate {
  return { errors: [] };
}

export const ErrorsUpdate: MessageFns<ErrorsUpdate> = {
  encode(message: ErrorsUpdate, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    for (const v of message.errors) {
      FunctionError.encode(v!, writer.uint32(10).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ErrorsUpdate {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseErrorsUpdate();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.errors.push(FunctionError.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): ErrorsUpdate {
    return {
      errors: globalThis.Array.isArray(object?.errors) ? object.errors.map((e: any) => FunctionError.fromJSON(e)) : [],
    };
  },

  toJSON(message: ErrorsUpdate): unknown {
    const obj: any = {};
    if (message.errors?.length) {
      obj.errors = message.errors.map((e) => FunctionError.toJSON(e));
    }
    return obj;
  },

  create(base?: DeepPartial<ErrorsUpdate>): ErrorsUpdate {
    return ErrorsUpdate.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<ErrorsUpdate>): ErrorsUpdate {
    const message = createBaseErrorsUpdate();
    message.errors = object.errors?.map((e) => FunctionError.fromPartial(e)) || [];
    return message;
  },
};

function createBaseFunctionUpdateFunction(): FunctionUpdateFunction {
  return {
    id: "",
    name: undefined,
    description: undefined,
    parameters: undefined,
    code: undefined,
    errors: undefined,
    references: undefined,
    archived: undefined,
  };
}

export const FunctionUpdateFunction: MessageFns<FunctionUpdateFunction> = {
  encode(message: FunctionUpdateFunction, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.id !== "") {
      writer.uint32(10).string(message.id);
    }
    if (message.name !== undefined) {
      writer.uint32(18).string(message.name);
    }
    if (message.description !== undefined) {
      writer.uint32(26).string(message.description);
    }
    if (message.parameters !== undefined) {
      ParametersUpdate.encode(message.parameters, writer.uint32(34).fork()).join();
    }
    if (message.code !== undefined) {
      writer.uint32(42).string(message.code);
    }
    if (message.errors !== undefined) {
      ErrorsUpdate.encode(message.errors, writer.uint32(50).fork()).join();
    }
    if (message.references !== undefined) {
      FunctionReferences.encode(message.references, writer.uint32(58).fork()).join();
    }
    if (message.archived !== undefined) {
      writer.uint32(64).bool(message.archived);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): FunctionUpdateFunction {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseFunctionUpdateFunction();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.id = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.name = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.description = reader.string();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.parameters = ParametersUpdate.decode(reader, reader.uint32());
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.code = reader.string();
          continue;
        }
        case 6: {
          if (tag !== 50) {
            break;
          }

          message.errors = ErrorsUpdate.decode(reader, reader.uint32());
          continue;
        }
        case 7: {
          if (tag !== 58) {
            break;
          }

          message.references = FunctionReferences.decode(reader, reader.uint32());
          continue;
        }
        case 8: {
          if (tag !== 64) {
            break;
          }

          message.archived = reader.bool();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): FunctionUpdateFunction {
    return {
      id: isSet(object.id) ? globalThis.String(object.id) : "",
      name: isSet(object.name) ? globalThis.String(object.name) : undefined,
      description: isSet(object.description) ? globalThis.String(object.description) : undefined,
      parameters: isSet(object.parameters) ? ParametersUpdate.fromJSON(object.parameters) : undefined,
      code: isSet(object.code) ? globalThis.String(object.code) : undefined,
      errors: isSet(object.errors) ? ErrorsUpdate.fromJSON(object.errors) : undefined,
      references: isSet(object.references) ? FunctionReferences.fromJSON(object.references) : undefined,
      archived: isSet(object.archived) ? globalThis.Boolean(object.archived) : undefined,
    };
  },

  toJSON(message: FunctionUpdateFunction): unknown {
    const obj: any = {};
    if (message.id !== "") {
      obj.id = message.id;
    }
    if (message.name !== undefined) {
      obj.name = message.name;
    }
    if (message.description !== undefined) {
      obj.description = message.description;
    }
    if (message.parameters !== undefined) {
      obj.parameters = ParametersUpdate.toJSON(message.parameters);
    }
    if (message.code !== undefined) {
      obj.code = message.code;
    }
    if (message.errors !== undefined) {
      obj.errors = ErrorsUpdate.toJSON(message.errors);
    }
    if (message.references !== undefined) {
      obj.references = FunctionReferences.toJSON(message.references);
    }
    if (message.archived !== undefined) {
      obj.archived = message.archived;
    }
    return obj;
  },

  create(base?: DeepPartial<FunctionUpdateFunction>): FunctionUpdateFunction {
    return FunctionUpdateFunction.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<FunctionUpdateFunction>): FunctionUpdateFunction {
    const message = createBaseFunctionUpdateFunction();
    message.id = object.id ?? "";
    message.name = object.name ?? undefined;
    message.description = object.description ?? undefined;
    message.parameters = (object.parameters !== undefined && object.parameters !== null)
      ? ParametersUpdate.fromPartial(object.parameters)
      : undefined;
    message.code = object.code ?? undefined;
    message.errors = (object.errors !== undefined && object.errors !== null)
      ? ErrorsUpdate.fromPartial(object.errors)
      : undefined;
    message.references = (object.references !== undefined && object.references !== null)
      ? FunctionReferences.fromPartial(object.references)
      : undefined;
    message.archived = object.archived ?? undefined;
    return message;
  },
};

function createBaseFunctionDeleteFunction(): FunctionDeleteFunction {
  return { id: "" };
}

export const FunctionDeleteFunction: MessageFns<FunctionDeleteFunction> = {
  encode(message: FunctionDeleteFunction, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.id !== "") {
      writer.uint32(10).string(message.id);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): FunctionDeleteFunction {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseFunctionDeleteFunction();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.id = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): FunctionDeleteFunction {
    return { id: isSet(object.id) ? globalThis.String(object.id) : "" };
  },

  toJSON(message: FunctionDeleteFunction): unknown {
    const obj: any = {};
    if (message.id !== "") {
      obj.id = message.id;
    }
    return obj;
  },

  create(base?: DeepPartial<FunctionDeleteFunction>): FunctionDeleteFunction {
    return FunctionDeleteFunction.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<FunctionDeleteFunction>): FunctionDeleteFunction {
    const message = createBaseFunctionDeleteFunction();
    message.id = object.id ?? "";
    return message;
  },
};

function createBaseDelayResponseUpdate(): DelayResponseUpdate {
  return { id: "", message: "", duration: 0, references: undefined };
}

export const DelayResponseUpdate: MessageFns<DelayResponseUpdate> = {
  encode(message: DelayResponseUpdate, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.id !== "") {
      writer.uint32(10).string(message.id);
    }
    if (message.message !== "") {
      writer.uint32(18).string(message.message);
    }
    if (message.duration !== 0) {
      writer.uint32(24).int32(message.duration);
    }
    if (message.references !== undefined) {
      FunctionDelayResponseReferences.encode(message.references, writer.uint32(34).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): DelayResponseUpdate {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseDelayResponseUpdate();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.id = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.message = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 24) {
            break;
          }

          message.duration = reader.int32();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.references = FunctionDelayResponseReferences.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): DelayResponseUpdate {
    return {
      id: isSet(object.id) ? globalThis.String(object.id) : "",
      message: isSet(object.message) ? globalThis.String(object.message) : "",
      duration: isSet(object.duration) ? globalThis.Number(object.duration) : 0,
      references: isSet(object.references) ? FunctionDelayResponseReferences.fromJSON(object.references) : undefined,
    };
  },

  toJSON(message: DelayResponseUpdate): unknown {
    const obj: any = {};
    if (message.id !== "") {
      obj.id = message.id;
    }
    if (message.message !== "") {
      obj.message = message.message;
    }
    if (message.duration !== 0) {
      obj.duration = Math.round(message.duration);
    }
    if (message.references !== undefined) {
      obj.references = FunctionDelayResponseReferences.toJSON(message.references);
    }
    return obj;
  },

  create(base?: DeepPartial<DelayResponseUpdate>): DelayResponseUpdate {
    return DelayResponseUpdate.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<DelayResponseUpdate>): DelayResponseUpdate {
    const message = createBaseDelayResponseUpdate();
    message.id = object.id ?? "";
    message.message = object.message ?? "";
    message.duration = object.duration ?? 0;
    message.references = (object.references !== undefined && object.references !== null)
      ? FunctionDelayResponseReferences.fromPartial(object.references)
      : undefined;
    return message;
  },
};

function createBaseDelayResponsesUpdate(): DelayResponsesUpdate {
  return { delayResponses: [] };
}

export const DelayResponsesUpdate: MessageFns<DelayResponsesUpdate> = {
  encode(message: DelayResponsesUpdate, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    for (const v of message.delayResponses) {
      DelayResponseUpdate.encode(v!, writer.uint32(10).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): DelayResponsesUpdate {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseDelayResponsesUpdate();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.delayResponses.push(DelayResponseUpdate.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): DelayResponsesUpdate {
    return {
      delayResponses: globalThis.Array.isArray(object?.delayResponses)
        ? object.delayResponses.map((e: any) => DelayResponseUpdate.fromJSON(e))
        : globalThis.Array.isArray(object?.delay_responses)
        ? object.delay_responses.map((e: any) => DelayResponseUpdate.fromJSON(e))
        : [],
    };
  },

  toJSON(message: DelayResponsesUpdate): unknown {
    const obj: any = {};
    if (message.delayResponses?.length) {
      obj.delayResponses = message.delayResponses.map((e) => DelayResponseUpdate.toJSON(e));
    }
    return obj;
  },

  create(base?: DeepPartial<DelayResponsesUpdate>): DelayResponsesUpdate {
    return DelayResponsesUpdate.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<DelayResponsesUpdate>): DelayResponsesUpdate {
    const message = createBaseDelayResponsesUpdate();
    message.delayResponses = object.delayResponses?.map((e) => DelayResponseUpdate.fromPartial(e)) || [];
    return message;
  },
};

function createBaseFunctionUpdateLatencyControl(): FunctionUpdateLatencyControl {
  return { functionId: "", enabled: false, delayResponses: undefined, initialDelay: undefined, interval: undefined };
}

export const FunctionUpdateLatencyControl: MessageFns<FunctionUpdateLatencyControl> = {
  encode(message: FunctionUpdateLatencyControl, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.functionId !== "") {
      writer.uint32(10).string(message.functionId);
    }
    if (message.enabled !== false) {
      writer.uint32(16).bool(message.enabled);
    }
    if (message.delayResponses !== undefined) {
      DelayResponsesUpdate.encode(message.delayResponses, writer.uint32(26).fork()).join();
    }
    if (message.initialDelay !== undefined) {
      writer.uint32(32).int32(message.initialDelay);
    }
    if (message.interval !== undefined) {
      writer.uint32(40).int32(message.interval);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): FunctionUpdateLatencyControl {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseFunctionUpdateLatencyControl();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.functionId = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.enabled = reader.bool();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.delayResponses = DelayResponsesUpdate.decode(reader, reader.uint32());
          continue;
        }
        case 4: {
          if (tag !== 32) {
            break;
          }

          message.initialDelay = reader.int32();
          continue;
        }
        case 5: {
          if (tag !== 40) {
            break;
          }

          message.interval = reader.int32();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): FunctionUpdateLatencyControl {
    return {
      functionId: isSet(object.functionId)
        ? globalThis.String(object.functionId)
        : isSet(object.function_id)
        ? globalThis.String(object.function_id)
        : "",
      enabled: isSet(object.enabled) ? globalThis.Boolean(object.enabled) : false,
      delayResponses: isSet(object.delayResponses)
        ? DelayResponsesUpdate.fromJSON(object.delayResponses)
        : isSet(object.delay_responses)
        ? DelayResponsesUpdate.fromJSON(object.delay_responses)
        : undefined,
      initialDelay: isSet(object.initialDelay)
        ? globalThis.Number(object.initialDelay)
        : isSet(object.initial_delay)
        ? globalThis.Number(object.initial_delay)
        : undefined,
      interval: isSet(object.interval) ? globalThis.Number(object.interval) : undefined,
    };
  },

  toJSON(message: FunctionUpdateLatencyControl): unknown {
    const obj: any = {};
    if (message.functionId !== "") {
      obj.functionId = message.functionId;
    }
    if (message.enabled !== false) {
      obj.enabled = message.enabled;
    }
    if (message.delayResponses !== undefined) {
      obj.delayResponses = DelayResponsesUpdate.toJSON(message.delayResponses);
    }
    if (message.initialDelay !== undefined) {
      obj.initialDelay = Math.round(message.initialDelay);
    }
    if (message.interval !== undefined) {
      obj.interval = Math.round(message.interval);
    }
    return obj;
  },

  create(base?: DeepPartial<FunctionUpdateLatencyControl>): FunctionUpdateLatencyControl {
    return FunctionUpdateLatencyControl.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<FunctionUpdateLatencyControl>): FunctionUpdateLatencyControl {
    const message = createBaseFunctionUpdateLatencyControl();
    message.functionId = object.functionId ?? "";
    message.enabled = object.enabled ?? false;
    message.delayResponses = (object.delayResponses !== undefined && object.delayResponses !== null)
      ? DelayResponsesUpdate.fromPartial(object.delayResponses)
      : undefined;
    message.initialDelay = object.initialDelay ?? undefined;
    message.interval = object.interval ?? undefined;
    return message;
  },
};

type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined;

export type DeepPartial<T> = T extends Builtin ? T
  : T extends Long ? string | number | Long : T extends globalThis.Array<infer U> ? globalThis.Array<DeepPartial<U>>
  : T extends ReadonlyArray<infer U> ? ReadonlyArray<DeepPartial<U>>
  : T extends { $case: string; value: unknown } ? { $case: T["$case"]; value?: DeepPartial<T["value"]> }
  : T extends {} ? { [K in keyof T]?: DeepPartial<T[K]> }
  : Partial<T>;

function toTimestamp(date: Date): Timestamp {
  const seconds = numberToLong(Math.trunc(date.getTime() / 1_000));
  const nanos = (date.getTime() % 1_000) * 1_000_000;
  return { seconds, nanos };
}

function fromTimestamp(t: Timestamp): Date {
  let millis = (t.seconds.toNumber() || 0) * 1_000;
  millis += (t.nanos || 0) / 1_000_000;
  return new globalThis.Date(millis);
}

function fromJsonTimestamp(o: any): Date {
  if (o instanceof globalThis.Date) {
    return o;
  } else if (typeof o === "string") {
    return new globalThis.Date(o);
  } else {
    return fromTimestamp(Timestamp.fromJSON(o));
  }
}

function numberToLong(number: number) {
  return Long.fromNumber(number);
}

function isObject(value: any): boolean {
  return typeof value === "object" && value !== null;
}

function isSet(value: any): boolean {
  return value !== null && value !== undefined;
}

export interface MessageFns<T> {
  encode(message: T, writer?: BinaryWriter): BinaryWriter;
  decode(input: BinaryReader | Uint8Array, length?: number): T;
  fromJSON(object: any): T;
  toJSON(message: T): unknown;
  create(base?: DeepPartial<T>): T;
  fromPartial(object: DeepPartial<T>): T;
}
